<div class="main-layout" [style.--open-toasts-count]="openToastsCount()">

  <ui-toast></ui-toast>

  <app-menu class="menu cc-header"></app-menu>

  <div class="container">
    <router-outlet></router-outlet>
  </div>

  <app-bottom></app-bottom>
</div>